__webpack_require__.p = "/فيلا سيجنتشر/_next/";